import "../assets/ConflictPicker-8e1eb7d1.css";
import { extname as Ns, basename as Ps } from "path";
import { Node as Cs, File as Tt, Folder as Nt, formatFileSize as Rs, FileType as Fs } from "@nextcloud/files";
import { showError as Ws } from "@nextcloud/dialogs";
import It from "vue";
import Ls from "@nextcloud/vue/dist/Components/NcButton.js";
import Ut from "@nextcloud/vue/dist/Components/NcCheckboxRadioSwitch.js";
import Is from "@nextcloud/vue/dist/Components/NcModal.js";
import { n as Me, t as pe, a as Qe, l as se } from "./index-f812dc31.mjs";
import { generateUrl as Us } from "@nextcloud/router";
const As = {
  name: "ArrowRightIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Es = function() {
  var t = this, s = t._self._c;
  return s("span", t._b({ staticClass: "material-design-icon arrow-right-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(i) {
    return t.$emit("click", i);
  } } }, "span", t.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" } }, [t.title ? s("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, Hs = [], Vs = /* @__PURE__ */ Me(
  As,
  Es,
  Hs,
  !1,
  null,
  null,
  null,
  null
);
const $s = Vs.exports, Gs = {
  name: "CloseIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var zs = function() {
  var t = this, s = t._self._c;
  return s("span", t._b({ staticClass: "material-design-icon close-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(i) {
    return t.$emit("click", i);
  } } }, "span", t.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" } }, [t.title ? s("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, js = [], Zs = /* @__PURE__ */ Me(
  Gs,
  zs,
  js,
  !1,
  null,
  null,
  null,
  null
);
const Bs = Zs.exports;
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var At;
function o() {
  return At.apply(null, arguments);
}
function qs(e) {
  At = e;
}
function L(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function ne(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function y(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function ut(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (y(e, t))
      return !1;
  return !0;
}
function T(e) {
  return e === void 0;
}
function q(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function De(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Et(e, t) {
  var s = [], i, r = e.length;
  for (i = 0; i < r; ++i)
    s.push(t(e[i], i));
  return s;
}
function K(e, t) {
  for (var s in t)
    y(t, s) && (e[s] = t[s]);
  return y(t, "toString") && (e.toString = t.toString), y(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function H(e, t, s, i) {
  return ds(e, t, s, i, !0).utc();
}
function Js() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function h(e) {
  return e._pf == null && (e._pf = Js()), e._pf;
}
var st;
Array.prototype.some ? st = Array.prototype.some : st = function(e) {
  var t = Object(this), s = t.length >>> 0, i;
  for (i = 0; i < s; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function dt(e) {
  if (e._isValid == null) {
    var t = h(e), s = st.call(t.parsedDateParts, function(r) {
      return r != null;
    }), i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && s);
    if (e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function Ae(e) {
  var t = H(NaN);
  return e != null ? K(h(t), e) : h(t).userInvalidated = !0, t;
}
var Pt = o.momentProperties = [], Xe = !1;
function ct(e, t) {
  var s, i, r, n = Pt.length;
  if (T(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), T(t._i) || (e._i = t._i), T(t._f) || (e._f = t._f), T(t._l) || (e._l = t._l), T(t._strict) || (e._strict = t._strict), T(t._tzm) || (e._tzm = t._tzm), T(t._isUTC) || (e._isUTC = t._isUTC), T(t._offset) || (e._offset = t._offset), T(t._pf) || (e._pf = h(t)), T(t._locale) || (e._locale = t._locale), n > 0)
    for (s = 0; s < n; s++)
      i = Pt[s], r = t[i], T(r) || (e[i] = r);
  return e;
}
function Ye(e) {
  ct(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Xe === !1 && (Xe = !0, o.updateOffset(this), Xe = !1);
}
function I(e) {
  return e instanceof Ye || e != null && e._isAMomentObject != null;
}
function Ht(e) {
  o.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function R(e, t) {
  var s = !0;
  return K(function() {
    if (o.deprecationHandler != null && o.deprecationHandler(null, e), s) {
      var i = [], r, n, a, d = arguments.length;
      for (n = 0; n < d; n++) {
        if (r = "", typeof arguments[n] == "object") {
          r += `
[` + n + "] ";
          for (a in arguments[0])
            y(arguments[0], a) && (r += a + ": " + arguments[0][a] + ", ");
          r = r.slice(0, -2);
        } else
          r = arguments[n];
        i.push(r);
      }
      Ht(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), s = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Ct = {};
function Vt(e, t) {
  o.deprecationHandler != null && o.deprecationHandler(e, t), Ct[e] || (Ht(t), Ct[e] = !0);
}
o.suppressDeprecationWarnings = !1;
o.deprecationHandler = null;
function V(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Qs(e) {
  var t, s;
  for (s in e)
    y(e, s) && (t = e[s], V(t) ? this[s] = t : this["_" + s] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function it(e, t) {
  var s = K({}, e), i;
  for (i in t)
    y(t, i) && (ne(e[i]) && ne(t[i]) ? (s[i] = {}, K(s[i], e[i]), K(s[i], t[i])) : t[i] != null ? s[i] = t[i] : delete s[i]);
  for (i in e)
    y(e, i) && !y(t, i) && ne(e[i]) && (s[i] = K({}, s[i]));
  return s;
}
function ht(e) {
  e != null && this.set(e);
}
var rt;
Object.keys ? rt = Object.keys : rt = function(e) {
  var t, s = [];
  for (t in e)
    y(e, t) && s.push(t);
  return s;
};
var Xs = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Ks(e, t, s) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return V(i) ? i.call(t, s) : i;
}
function E(e, t, s) {
  var i = "" + Math.abs(e), r = t - i.length, n = e >= 0;
  return (n ? s ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + i;
}
var ft = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, xe = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Ke = {}, de = {};
function c(e, t, s, i) {
  var r = i;
  typeof i == "string" && (r = function() {
    return this[i]();
  }), e && (de[e] = r), t && (de[t[0]] = function() {
    return E(r.apply(this, arguments), t[1], t[2]);
  }), s && (de[s] = function() {
    return this.localeData().ordinal(
      r.apply(this, arguments),
      e
    );
  });
}
function ei(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function ti(e) {
  var t = e.match(ft), s, i;
  for (s = 0, i = t.length; s < i; s++)
    de[t[s]] ? t[s] = de[t[s]] : t[s] = ei(t[s]);
  return function(r) {
    var n = "", a;
    for (a = 0; a < i; a++)
      n += V(t[a]) ? t[a].call(r, e) : t[a];
    return n;
  };
}
function Ne(e, t) {
  return e.isValid() ? (t = $t(t, e.localeData()), Ke[t] = Ke[t] || ti(t), Ke[t](e)) : e.localeData().invalidDate();
}
function $t(e, t) {
  var s = 5;
  function i(r) {
    return t.longDateFormat(r) || r;
  }
  for (xe.lastIndex = 0; s >= 0 && xe.test(e); )
    e = e.replace(
      xe,
      i
    ), xe.lastIndex = 0, s -= 1;
  return e;
}
var si = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function ii(e) {
  var t = this._longDateFormat[e], s = this._longDateFormat[e.toUpperCase()];
  return t || !s ? t : (this._longDateFormat[e] = s.match(ft).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var ri = "Invalid date";
function ni() {
  return this._invalidDate;
}
var ai = "%d", li = /\d{1,2}/;
function oi(e) {
  return this._ordinal.replace("%d", e);
}
var ui = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function di(e, t, s, i) {
  var r = this._relativeTime[s];
  return V(r) ? r(e, t, s, i) : r.replace(/%d/i, e);
}
function ci(e, t) {
  var s = this._relativeTime[e > 0 ? "future" : "past"];
  return V(s) ? s(t) : s.replace(/%s/i, t);
}
var we = {};
function O(e, t) {
  var s = e.toLowerCase();
  we[s] = we[s + "s"] = we[t] = e;
}
function F(e) {
  return typeof e == "string" ? we[e] || we[e.toLowerCase()] : void 0;
}
function mt(e) {
  var t = {}, s, i;
  for (i in e)
    y(e, i) && (s = F(i), s && (t[s] = e[i]));
  return t;
}
var Gt = {};
function b(e, t) {
  Gt[e] = t;
}
function hi(e) {
  var t = [], s;
  for (s in e)
    y(e, s) && t.push({ unit: s, priority: Gt[s] });
  return t.sort(function(i, r) {
    return i.priority - r.priority;
  }), t;
}
function Ee(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function C(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function m(e) {
  var t = +e, s = 0;
  return t !== 0 && isFinite(t) && (s = C(t)), s;
}
function fe(e, t) {
  return function(s) {
    return s != null ? (zt(this, e, s), o.updateOffset(this, t), this) : Re(this, e);
  };
}
function Re(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function zt(e, t, s) {
  e.isValid() && !isNaN(s) && (t === "FullYear" && Ee(e.year()) && e.month() === 1 && e.date() === 29 ? (s = m(s), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    s,
    e.month(),
    je(s, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](s));
}
function fi(e) {
  return e = F(e), V(this[e]) ? this[e]() : this;
}
function mi(e, t) {
  if (typeof e == "object") {
    e = mt(e);
    var s = hi(e), i, r = s.length;
    for (i = 0; i < r; i++)
      this[s[i].unit](e[s[i].unit]);
  } else if (e = F(e), V(this[e]))
    return this[e](t);
  return this;
}
var jt = /\d/, P = /\d\d/, Zt = /\d{3}/, _t = /\d{4}/, He = /[+-]?\d{6}/, k = /\d\d?/, Bt = /\d\d\d\d?/, qt = /\d\d\d\d\d\d?/, Ve = /\d{1,3}/, yt = /\d{1,4}/, $e = /[+-]?\d{1,6}/, me = /\d+/, Ge = /[+-]?\d+/, _i = /Z|[+-]\d\d:?\d\d/gi, ze = /Z|[+-]\d\d(?::?\d\d)?/gi, yi = /[+-]?\d+(\.\d{1,3})?/, Oe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Fe;
Fe = {};
function u(e, t, s) {
  Fe[e] = V(t) ? t : function(i, r) {
    return i && s ? s : t;
  };
}
function pi(e, t) {
  return y(Fe, e) ? Fe[e](t._strict, t._locale) : new RegExp(wi(e));
}
function wi(e) {
  return N(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, s, i, r, n) {
        return s || i || r || n;
      }
    )
  );
}
function N(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var nt = {};
function g(e, t) {
  var s, i = t, r;
  for (typeof e == "string" && (e = [e]), q(t) && (i = function(n, a) {
    a[t] = m(n);
  }), r = e.length, s = 0; s < r; s++)
    nt[e[s]] = i;
}
function be(e, t) {
  g(e, function(s, i, r, n) {
    r._w = r._w || {}, t(s, r._w, r, n);
  });
}
function gi(e, t, s) {
  t != null && y(nt, e) && nt[e](t, s._a, s, e);
}
var Y = 0, j = 1, A = 2, D = 3, W = 4, Z = 5, re = 6, Si = 7, ki = 8;
function vi(e, t) {
  return (e % t + t) % t;
}
var M;
Array.prototype.indexOf ? M = Array.prototype.indexOf : M = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function je(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var s = vi(t, 12);
  return e += (t - s) / 12, s === 1 ? Ee(e) ? 29 : 28 : 31 - s % 7 % 2;
}
c("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
c("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
c("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
O("month", "M");
b("month", 8);
u("M", k);
u("MM", k, P);
u("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
u("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
g(["M", "MM"], function(e, t) {
  t[j] = m(e) - 1;
});
g(["MMM", "MMMM"], function(e, t, s, i) {
  var r = s._locale.monthsParse(e, i, s._strict);
  r != null ? t[j] = r : h(s).invalidMonth = e;
});
var Mi = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Jt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Qt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Di = Oe, Yi = Oe;
function Oi(e, t) {
  return e ? L(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Qt).test(t) ? "format" : "standalone"][e.month()] : L(this._months) ? this._months : this._months.standalone;
}
function bi(e, t) {
  return e ? L(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Qt.test(t) ? "format" : "standalone"][e.month()] : L(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function xi(e, t, s) {
  var i, r, n, a = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      n = H([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        n,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(n, "").toLocaleLowerCase();
  return s ? t === "MMM" ? (r = M.call(this._shortMonthsParse, a), r !== -1 ? r : null) : (r = M.call(this._longMonthsParse, a), r !== -1 ? r : null) : t === "MMM" ? (r = M.call(this._shortMonthsParse, a), r !== -1 ? r : (r = M.call(this._longMonthsParse, a), r !== -1 ? r : null)) : (r = M.call(this._longMonthsParse, a), r !== -1 ? r : (r = M.call(this._shortMonthsParse, a), r !== -1 ? r : null));
}
function Ti(e, t, s) {
  var i, r, n;
  if (this._monthsParseExact)
    return xi.call(this, e, t, s);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++) {
    if (r = H([2e3, i]), s && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(r, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(r, "").replace(".", "") + "$",
      "i"
    )), !s && !this._monthsParse[i] && (n = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[i] = new RegExp(n.replace(".", ""), "i")), s && t === "MMMM" && this._longMonthsParse[i].test(e))
      return i;
    if (s && t === "MMM" && this._shortMonthsParse[i].test(e))
      return i;
    if (!s && this._monthsParse[i].test(e))
      return i;
  }
}
function Xt(e, t) {
  var s;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = m(t);
    else if (t = e.localeData().monthsParse(t), !q(t))
      return e;
  }
  return s = Math.min(e.date(), je(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, s), e;
}
function Kt(e) {
  return e != null ? (Xt(this, e), o.updateOffset(this, !0), this) : Re(this, "Month");
}
function Ni() {
  return je(this.year(), this.month());
}
function Pi(e) {
  return this._monthsParseExact ? (y(this, "_monthsRegex") || es.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (y(this, "_monthsShortRegex") || (this._monthsShortRegex = Di), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Ci(e) {
  return this._monthsParseExact ? (y(this, "_monthsRegex") || es.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (y(this, "_monthsRegex") || (this._monthsRegex = Yi), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function es() {
  function e(a, d) {
    return d.length - a.length;
  }
  var t = [], s = [], i = [], r, n;
  for (r = 0; r < 12; r++)
    n = H([2e3, r]), t.push(this.monthsShort(n, "")), s.push(this.months(n, "")), i.push(this.months(n, "")), i.push(this.monthsShort(n, ""));
  for (t.sort(e), s.sort(e), i.sort(e), r = 0; r < 12; r++)
    t[r] = N(t[r]), s[r] = N(s[r]);
  for (r = 0; r < 24; r++)
    i[r] = N(i[r]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
c("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? E(e, 4) : "+" + e;
});
c(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
c(0, ["YYYY", 4], 0, "year");
c(0, ["YYYYY", 5], 0, "year");
c(0, ["YYYYYY", 6, !0], 0, "year");
O("year", "y");
b("year", 1);
u("Y", Ge);
u("YY", k, P);
u("YYYY", yt, _t);
u("YYYYY", $e, He);
u("YYYYYY", $e, He);
g(["YYYYY", "YYYYYY"], Y);
g("YYYY", function(e, t) {
  t[Y] = e.length === 2 ? o.parseTwoDigitYear(e) : m(e);
});
g("YY", function(e, t) {
  t[Y] = o.parseTwoDigitYear(e);
});
g("Y", function(e, t) {
  t[Y] = parseInt(e, 10);
});
function ge(e) {
  return Ee(e) ? 366 : 365;
}
o.parseTwoDigitYear = function(e) {
  return m(e) + (m(e) > 68 ? 1900 : 2e3);
};
var ts = fe("FullYear", !0);
function Ri() {
  return Ee(this.year());
}
function Fi(e, t, s, i, r, n, a) {
  var d;
  return e < 100 && e >= 0 ? (d = new Date(e + 400, t, s, i, r, n, a), isFinite(d.getFullYear()) && d.setFullYear(e)) : d = new Date(e, t, s, i, r, n, a), d;
}
function Se(e) {
  var t, s;
  return e < 100 && e >= 0 ? (s = Array.prototype.slice.call(arguments), s[0] = e + 400, t = new Date(Date.UTC.apply(null, s)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function We(e, t, s) {
  var i = 7 + t - s, r = (7 + Se(e, 0, i).getUTCDay() - t) % 7;
  return -r + i - 1;
}
function ss(e, t, s, i, r) {
  var n = (7 + s - i) % 7, a = We(e, i, r), d = 1 + 7 * (t - 1) + n + a, f, w;
  return d <= 0 ? (f = e - 1, w = ge(f) + d) : d > ge(e) ? (f = e + 1, w = d - ge(e)) : (f = e, w = d), {
    year: f,
    dayOfYear: w
  };
}
function ke(e, t, s) {
  var i = We(e.year(), t, s), r = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, n, a;
  return r < 1 ? (a = e.year() - 1, n = r + B(a, t, s)) : r > B(e.year(), t, s) ? (n = r - B(e.year(), t, s), a = e.year() + 1) : (a = e.year(), n = r), {
    week: n,
    year: a
  };
}
function B(e, t, s) {
  var i = We(e, t, s), r = We(e + 1, t, s);
  return (ge(e) - i + r) / 7;
}
c("w", ["ww", 2], "wo", "week");
c("W", ["WW", 2], "Wo", "isoWeek");
O("week", "w");
O("isoWeek", "W");
b("week", 5);
b("isoWeek", 5);
u("w", k);
u("ww", k, P);
u("W", k);
u("WW", k, P);
be(
  ["w", "ww", "W", "WW"],
  function(e, t, s, i) {
    t[i.substr(0, 1)] = m(e);
  }
);
function Wi(e) {
  return ke(e, this._week.dow, this._week.doy).week;
}
var Li = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Ii() {
  return this._week.dow;
}
function Ui() {
  return this._week.doy;
}
function Ai(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Ei(e) {
  var t = ke(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
c("d", 0, "do", "day");
c("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
c("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
c("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
c("e", 0, 0, "weekday");
c("E", 0, 0, "isoWeekday");
O("day", "d");
O("weekday", "e");
O("isoWeekday", "E");
b("day", 11);
b("weekday", 11);
b("isoWeekday", 11);
u("d", k);
u("e", k);
u("E", k);
u("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
u("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
u("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
be(["dd", "ddd", "dddd"], function(e, t, s, i) {
  var r = s._locale.weekdaysParse(e, i, s._strict);
  r != null ? t.d = r : h(s).invalidWeekday = e;
});
be(["d", "e", "E"], function(e, t, s, i) {
  t[i] = m(e);
});
function Hi(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Vi(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function pt(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var $i = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), is = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Gi = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), zi = Oe, ji = Oe, Zi = Oe;
function Bi(e, t) {
  var s = L(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? pt(s, this._week.dow) : e ? s[e.day()] : s;
}
function qi(e) {
  return e === !0 ? pt(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Ji(e) {
  return e === !0 ? pt(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Qi(e, t, s) {
  var i, r, n, a = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      n = H([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        n,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        n,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(n, "").toLocaleLowerCase();
  return s ? t === "dddd" ? (r = M.call(this._weekdaysParse, a), r !== -1 ? r : null) : t === "ddd" ? (r = M.call(this._shortWeekdaysParse, a), r !== -1 ? r : null) : (r = M.call(this._minWeekdaysParse, a), r !== -1 ? r : null) : t === "dddd" ? (r = M.call(this._weekdaysParse, a), r !== -1 || (r = M.call(this._shortWeekdaysParse, a), r !== -1) ? r : (r = M.call(this._minWeekdaysParse, a), r !== -1 ? r : null)) : t === "ddd" ? (r = M.call(this._shortWeekdaysParse, a), r !== -1 || (r = M.call(this._weekdaysParse, a), r !== -1) ? r : (r = M.call(this._minWeekdaysParse, a), r !== -1 ? r : null)) : (r = M.call(this._minWeekdaysParse, a), r !== -1 || (r = M.call(this._weekdaysParse, a), r !== -1) ? r : (r = M.call(this._shortWeekdaysParse, a), r !== -1 ? r : null));
}
function Xi(e, t, s) {
  var i, r, n;
  if (this._weekdaysParseExact)
    return Qi.call(this, e, t, s);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++) {
    if (r = H([2e3, 1]).day(i), s && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (n = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[i] = new RegExp(n.replace(".", ""), "i")), s && t === "dddd" && this._fullWeekdaysParse[i].test(e))
      return i;
    if (s && t === "ddd" && this._shortWeekdaysParse[i].test(e))
      return i;
    if (s && t === "dd" && this._minWeekdaysParse[i].test(e))
      return i;
    if (!s && this._weekdaysParse[i].test(e))
      return i;
  }
}
function Ki(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Hi(e, this.localeData()), this.add(e - t, "d")) : t;
}
function er(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function tr(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Vi(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function sr(e) {
  return this._weekdaysParseExact ? (y(this, "_weekdaysRegex") || wt.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (y(this, "_weekdaysRegex") || (this._weekdaysRegex = zi), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function ir(e) {
  return this._weekdaysParseExact ? (y(this, "_weekdaysRegex") || wt.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (y(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = ji), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function rr(e) {
  return this._weekdaysParseExact ? (y(this, "_weekdaysRegex") || wt.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (y(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Zi), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function wt() {
  function e(x, $) {
    return $.length - x.length;
  }
  var t = [], s = [], i = [], r = [], n, a, d, f, w;
  for (n = 0; n < 7; n++)
    a = H([2e3, 1]).day(n), d = N(this.weekdaysMin(a, "")), f = N(this.weekdaysShort(a, "")), w = N(this.weekdays(a, "")), t.push(d), s.push(f), i.push(w), r.push(d), r.push(f), r.push(w);
  t.sort(e), s.sort(e), i.sort(e), r.sort(e), this._weekdaysRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function gt() {
  return this.hours() % 12 || 12;
}
function nr() {
  return this.hours() || 24;
}
c("H", ["HH", 2], 0, "hour");
c("h", ["hh", 2], 0, gt);
c("k", ["kk", 2], 0, nr);
c("hmm", 0, 0, function() {
  return "" + gt.apply(this) + E(this.minutes(), 2);
});
c("hmmss", 0, 0, function() {
  return "" + gt.apply(this) + E(this.minutes(), 2) + E(this.seconds(), 2);
});
c("Hmm", 0, 0, function() {
  return "" + this.hours() + E(this.minutes(), 2);
});
c("Hmmss", 0, 0, function() {
  return "" + this.hours() + E(this.minutes(), 2) + E(this.seconds(), 2);
});
function rs(e, t) {
  c(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
rs("a", !0);
rs("A", !1);
O("hour", "h");
b("hour", 13);
function ns(e, t) {
  return t._meridiemParse;
}
u("a", ns);
u("A", ns);
u("H", k);
u("h", k);
u("k", k);
u("HH", k, P);
u("hh", k, P);
u("kk", k, P);
u("hmm", Bt);
u("hmmss", qt);
u("Hmm", Bt);
u("Hmmss", qt);
g(["H", "HH"], D);
g(["k", "kk"], function(e, t, s) {
  var i = m(e);
  t[D] = i === 24 ? 0 : i;
});
g(["a", "A"], function(e, t, s) {
  s._isPm = s._locale.isPM(e), s._meridiem = e;
});
g(["h", "hh"], function(e, t, s) {
  t[D] = m(e), h(s).bigHour = !0;
});
g("hmm", function(e, t, s) {
  var i = e.length - 2;
  t[D] = m(e.substr(0, i)), t[W] = m(e.substr(i)), h(s).bigHour = !0;
});
g("hmmss", function(e, t, s) {
  var i = e.length - 4, r = e.length - 2;
  t[D] = m(e.substr(0, i)), t[W] = m(e.substr(i, 2)), t[Z] = m(e.substr(r)), h(s).bigHour = !0;
});
g("Hmm", function(e, t, s) {
  var i = e.length - 2;
  t[D] = m(e.substr(0, i)), t[W] = m(e.substr(i));
});
g("Hmmss", function(e, t, s) {
  var i = e.length - 4, r = e.length - 2;
  t[D] = m(e.substr(0, i)), t[W] = m(e.substr(i, 2)), t[Z] = m(e.substr(r));
});
function ar(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var lr = /[ap]\.?m?\.?/i, or = fe("Hours", !0);
function ur(e, t, s) {
  return e > 11 ? s ? "pm" : "PM" : s ? "am" : "AM";
}
var as = {
  calendar: Xs,
  longDateFormat: si,
  invalidDate: ri,
  ordinal: ai,
  dayOfMonthOrdinalParse: li,
  relativeTime: ui,
  months: Mi,
  monthsShort: Jt,
  week: Li,
  weekdays: $i,
  weekdaysMin: Gi,
  weekdaysShort: is,
  meridiemParse: lr
}, v = {}, _e = {}, ve;
function dr(e, t) {
  var s, i = Math.min(e.length, t.length);
  for (s = 0; s < i; s += 1)
    if (e[s] !== t[s])
      return s;
  return i;
}
function Rt(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function cr(e) {
  for (var t = 0, s, i, r, n; t < e.length; ) {
    for (n = Rt(e[t]).split("-"), s = n.length, i = Rt(e[t + 1]), i = i ? i.split("-") : null; s > 0; ) {
      if (r = Ze(n.slice(0, s).join("-")), r)
        return r;
      if (i && i.length >= s && dr(n, i) >= s - 1)
        break;
      s--;
    }
    t++;
  }
  return ve;
}
function hr(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Ze(e) {
  var t = null, s;
  if (v[e] === void 0 && typeof module < "u" && module && module.exports && hr(e))
    try {
      t = ve._abbr, s = require, s("./locale/" + e), te(t);
    } catch {
      v[e] = null;
    }
  return v[e];
}
function te(e, t) {
  var s;
  return e && (T(t) ? s = J(e) : s = St(e, t), s ? ve = s : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), ve._abbr;
}
function St(e, t) {
  if (t !== null) {
    var s, i = as;
    if (t.abbr = e, v[e] != null)
      Vt(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = v[e]._config;
    else if (t.parentLocale != null)
      if (v[t.parentLocale] != null)
        i = v[t.parentLocale]._config;
      else if (s = Ze(t.parentLocale), s != null)
        i = s._config;
      else
        return _e[t.parentLocale] || (_e[t.parentLocale] = []), _e[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return v[e] = new ht(it(i, t)), _e[e] && _e[e].forEach(function(r) {
      St(r.name, r.config);
    }), te(e), v[e];
  } else
    return delete v[e], null;
}
function fr(e, t) {
  if (t != null) {
    var s, i, r = as;
    v[e] != null && v[e].parentLocale != null ? v[e].set(it(v[e]._config, t)) : (i = Ze(e), i != null && (r = i._config), t = it(r, t), i == null && (t.abbr = e), s = new ht(t), s.parentLocale = v[e], v[e] = s), te(e);
  } else
    v[e] != null && (v[e].parentLocale != null ? (v[e] = v[e].parentLocale, e === te() && te(e)) : v[e] != null && delete v[e]);
  return v[e];
}
function J(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return ve;
  if (!L(e)) {
    if (t = Ze(e), t)
      return t;
    e = [e];
  }
  return cr(e);
}
function mr() {
  return rt(v);
}
function kt(e) {
  var t, s = e._a;
  return s && h(e).overflow === -2 && (t = s[j] < 0 || s[j] > 11 ? j : s[A] < 1 || s[A] > je(s[Y], s[j]) ? A : s[D] < 0 || s[D] > 24 || s[D] === 24 && (s[W] !== 0 || s[Z] !== 0 || s[re] !== 0) ? D : s[W] < 0 || s[W] > 59 ? W : s[Z] < 0 || s[Z] > 59 ? Z : s[re] < 0 || s[re] > 999 ? re : -1, h(e)._overflowDayOfYear && (t < Y || t > A) && (t = A), h(e)._overflowWeeks && t === -1 && (t = Si), h(e)._overflowWeekday && t === -1 && (t = ki), h(e).overflow = t), e;
}
var _r = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, yr = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, pr = /Z|[+-]\d\d(?::?\d\d)?/, Te = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], et = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], wr = /^\/?Date\((-?\d+)/i, gr = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Sr = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ls(e) {
  var t, s, i = e._i, r = _r.exec(i) || yr.exec(i), n, a, d, f, w = Te.length, x = et.length;
  if (r) {
    for (h(e).iso = !0, t = 0, s = w; t < s; t++)
      if (Te[t][1].exec(r[1])) {
        a = Te[t][0], n = Te[t][2] !== !1;
        break;
      }
    if (a == null) {
      e._isValid = !1;
      return;
    }
    if (r[3]) {
      for (t = 0, s = x; t < s; t++)
        if (et[t][1].exec(r[3])) {
          d = (r[2] || " ") + et[t][0];
          break;
        }
      if (d == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!n && d != null) {
      e._isValid = !1;
      return;
    }
    if (r[4])
      if (pr.exec(r[4]))
        f = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = a + (d || "") + (f || ""), Mt(e);
  } else
    e._isValid = !1;
}
function kr(e, t, s, i, r, n) {
  var a = [
    vr(e),
    Jt.indexOf(t),
    parseInt(s, 10),
    parseInt(i, 10),
    parseInt(r, 10)
  ];
  return n && a.push(parseInt(n, 10)), a;
}
function vr(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Mr(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Dr(e, t, s) {
  if (e) {
    var i = is.indexOf(e), r = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== r)
      return h(s).weekdayMismatch = !0, s._isValid = !1, !1;
  }
  return !0;
}
function Yr(e, t, s) {
  if (e)
    return Sr[e];
  if (t)
    return 0;
  var i = parseInt(s, 10), r = i % 100, n = (i - r) / 100;
  return n * 60 + r;
}
function os(e) {
  var t = gr.exec(Mr(e._i)), s;
  if (t) {
    if (s = kr(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Dr(t[1], s, e))
      return;
    e._a = s, e._tzm = Yr(t[8], t[9], t[10]), e._d = Se.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), h(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Or(e) {
  var t = wr.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (ls(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (os(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : o.createFromInputFallback(e);
}
o.createFromInputFallback = R(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function oe(e, t, s) {
  return e ?? t ?? s;
}
function br(e) {
  var t = new Date(o.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function vt(e) {
  var t, s, i = [], r, n, a;
  if (!e._d) {
    for (r = br(e), e._w && e._a[A] == null && e._a[j] == null && xr(e), e._dayOfYear != null && (a = oe(e._a[Y], r[Y]), (e._dayOfYear > ge(a) || e._dayOfYear === 0) && (h(e)._overflowDayOfYear = !0), s = Se(a, 0, e._dayOfYear), e._a[j] = s.getUTCMonth(), e._a[A] = s.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = r[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[D] === 24 && e._a[W] === 0 && e._a[Z] === 0 && e._a[re] === 0 && (e._nextDay = !0, e._a[D] = 0), e._d = (e._useUTC ? Se : Fi).apply(
      null,
      i
    ), n = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[D] = 24), e._w && typeof e._w.d < "u" && e._w.d !== n && (h(e).weekdayMismatch = !0);
  }
}
function xr(e) {
  var t, s, i, r, n, a, d, f, w;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (n = 1, a = 4, s = oe(
    t.GG,
    e._a[Y],
    ke(S(), 1, 4).year
  ), i = oe(t.W, 1), r = oe(t.E, 1), (r < 1 || r > 7) && (f = !0)) : (n = e._locale._week.dow, a = e._locale._week.doy, w = ke(S(), n, a), s = oe(t.gg, e._a[Y], w.year), i = oe(t.w, w.week), t.d != null ? (r = t.d, (r < 0 || r > 6) && (f = !0)) : t.e != null ? (r = t.e + n, (t.e < 0 || t.e > 6) && (f = !0)) : r = n), i < 1 || i > B(s, n, a) ? h(e)._overflowWeeks = !0 : f != null ? h(e)._overflowWeekday = !0 : (d = ss(s, i, r, n, a), e._a[Y] = d.year, e._dayOfYear = d.dayOfYear);
}
o.ISO_8601 = function() {
};
o.RFC_2822 = function() {
};
function Mt(e) {
  if (e._f === o.ISO_8601) {
    ls(e);
    return;
  }
  if (e._f === o.RFC_2822) {
    os(e);
    return;
  }
  e._a = [], h(e).empty = !0;
  var t = "" + e._i, s, i, r, n, a, d = t.length, f = 0, w, x;
  for (r = $t(e._f, e._locale).match(ft) || [], x = r.length, s = 0; s < x; s++)
    n = r[s], i = (t.match(pi(n, e)) || [])[0], i && (a = t.substr(0, t.indexOf(i)), a.length > 0 && h(e).unusedInput.push(a), t = t.slice(
      t.indexOf(i) + i.length
    ), f += i.length), de[n] ? (i ? h(e).empty = !1 : h(e).unusedTokens.push(n), gi(n, i, e)) : e._strict && !i && h(e).unusedTokens.push(n);
  h(e).charsLeftOver = d - f, t.length > 0 && h(e).unusedInput.push(t), e._a[D] <= 12 && h(e).bigHour === !0 && e._a[D] > 0 && (h(e).bigHour = void 0), h(e).parsedDateParts = e._a.slice(0), h(e).meridiem = e._meridiem, e._a[D] = Tr(
    e._locale,
    e._a[D],
    e._meridiem
  ), w = h(e).era, w !== null && (e._a[Y] = e._locale.erasConvertYear(w, e._a[Y])), vt(e), kt(e);
}
function Tr(e, t, s) {
  var i;
  return s == null ? t : e.meridiemHour != null ? e.meridiemHour(t, s) : (e.isPM != null && (i = e.isPM(s), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function Nr(e) {
  var t, s, i, r, n, a, d = !1, f = e._f.length;
  if (f === 0) {
    h(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (r = 0; r < f; r++)
    n = 0, a = !1, t = ct({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[r], Mt(t), dt(t) && (a = !0), n += h(t).charsLeftOver, n += h(t).unusedTokens.length * 10, h(t).score = n, d ? n < i && (i = n, s = t) : (i == null || n < i || a) && (i = n, s = t, a && (d = !0));
  K(e, s || t);
}
function Pr(e) {
  if (!e._d) {
    var t = mt(e._i), s = t.day === void 0 ? t.date : t.day;
    e._a = Et(
      [t.year, t.month, s, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), vt(e);
  }
}
function Cr(e) {
  var t = new Ye(kt(us(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function us(e) {
  var t = e._i, s = e._f;
  return e._locale = e._locale || J(e._l), t === null || s === void 0 && t === "" ? Ae({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), I(t) ? new Ye(kt(t)) : (De(t) ? e._d = t : L(s) ? Nr(e) : s ? Mt(e) : Rr(e), dt(e) || (e._d = null), e));
}
function Rr(e) {
  var t = e._i;
  T(t) ? e._d = new Date(o.now()) : De(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Or(e) : L(t) ? (e._a = Et(t.slice(0), function(s) {
    return parseInt(s, 10);
  }), vt(e)) : ne(t) ? Pr(e) : q(t) ? e._d = new Date(t) : o.createFromInputFallback(e);
}
function ds(e, t, s, i, r) {
  var n = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (s === !0 || s === !1) && (i = s, s = void 0), (ne(e) && ut(e) || L(e) && e.length === 0) && (e = void 0), n._isAMomentObject = !0, n._useUTC = n._isUTC = r, n._l = s, n._i = e, n._f = t, n._strict = i, Cr(n);
}
function S(e, t, s, i) {
  return ds(e, t, s, i, !1);
}
var Fr = R(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = S.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Ae();
  }
), Wr = R(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = S.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Ae();
  }
);
function cs(e, t) {
  var s, i;
  if (t.length === 1 && L(t[0]) && (t = t[0]), !t.length)
    return S();
  for (s = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](s)) && (s = t[i]);
  return s;
}
function Lr() {
  var e = [].slice.call(arguments, 0);
  return cs("isBefore", e);
}
function Ir() {
  var e = [].slice.call(arguments, 0);
  return cs("isAfter", e);
}
var Ur = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ye = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Ar(e) {
  var t, s = !1, i, r = ye.length;
  for (t in e)
    if (y(e, t) && !(M.call(ye, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < r; ++i)
    if (e[ye[i]]) {
      if (s)
        return !1;
      parseFloat(e[ye[i]]) !== m(e[ye[i]]) && (s = !0);
    }
  return !0;
}
function Er() {
  return this._isValid;
}
function Hr() {
  return U(NaN);
}
function Be(e) {
  var t = mt(e), s = t.year || 0, i = t.quarter || 0, r = t.month || 0, n = t.week || t.isoWeek || 0, a = t.day || 0, d = t.hour || 0, f = t.minute || 0, w = t.second || 0, x = t.millisecond || 0;
  this._isValid = Ar(t), this._milliseconds = +x + w * 1e3 + // 1000
  f * 6e4 + // 1000 * 60
  d * 1e3 * 60 * 60, this._days = +a + n * 7, this._months = +r + i * 3 + s * 12, this._data = {}, this._locale = J(), this._bubble();
}
function Pe(e) {
  return e instanceof Be;
}
function at(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Vr(e, t, s) {
  var i = Math.min(e.length, t.length), r = Math.abs(e.length - t.length), n = 0, a;
  for (a = 0; a < i; a++)
    (s && e[a] !== t[a] || !s && m(e[a]) !== m(t[a])) && n++;
  return n + r;
}
function hs(e, t) {
  c(e, 0, 0, function() {
    var s = this.utcOffset(), i = "+";
    return s < 0 && (s = -s, i = "-"), i + E(~~(s / 60), 2) + t + E(~~s % 60, 2);
  });
}
hs("Z", ":");
hs("ZZ", "");
u("Z", ze);
u("ZZ", ze);
g(["Z", "ZZ"], function(e, t, s) {
  s._useUTC = !0, s._tzm = Dt(ze, e);
});
var $r = /([\+\-]|\d\d)/gi;
function Dt(e, t) {
  var s = (t || "").match(e), i, r, n;
  return s === null ? null : (i = s[s.length - 1] || [], r = (i + "").match($r) || ["-", 0, 0], n = +(r[1] * 60) + m(r[2]), n === 0 ? 0 : r[0] === "+" ? n : -n);
}
function Yt(e, t) {
  var s, i;
  return t._isUTC ? (s = t.clone(), i = (I(e) || De(e) ? e.valueOf() : S(e).valueOf()) - s.valueOf(), s._d.setTime(s._d.valueOf() + i), o.updateOffset(s, !1), s) : S(e).local();
}
function lt(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
o.updateOffset = function() {
};
function Gr(e, t, s) {
  var i = this._offset || 0, r;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Dt(ze, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !s && (e = e * 60);
    return !this._isUTC && t && (r = lt(this)), this._offset = e, this._isUTC = !0, r != null && this.add(r, "m"), i !== e && (!t || this._changeInProgress ? _s(
      this,
      U(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, o.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : lt(this);
}
function zr(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function jr(e) {
  return this.utcOffset(0, e);
}
function Zr(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(lt(this), "m")), this;
}
function Br() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Dt(_i, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function qr(e) {
  return this.isValid() ? (e = e ? S(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Jr() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Qr() {
  if (!T(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return ct(e, this), e = us(e), e._a ? (t = e._isUTC ? H(e._a) : S(e._a), this._isDSTShifted = this.isValid() && Vr(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Xr() {
  return this.isValid() ? !this._isUTC : !1;
}
function Kr() {
  return this.isValid() ? this._isUTC : !1;
}
function fs() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var en = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, tn = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function U(e, t) {
  var s = e, i = null, r, n, a;
  return Pe(e) ? s = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : q(e) || !isNaN(+e) ? (s = {}, t ? s[t] = +e : s.milliseconds = +e) : (i = en.exec(e)) ? (r = i[1] === "-" ? -1 : 1, s = {
    y: 0,
    d: m(i[A]) * r,
    h: m(i[D]) * r,
    m: m(i[W]) * r,
    s: m(i[Z]) * r,
    ms: m(at(i[re] * 1e3)) * r
    // the millisecond decimal point is included in the match
  }) : (i = tn.exec(e)) ? (r = i[1] === "-" ? -1 : 1, s = {
    y: ie(i[2], r),
    M: ie(i[3], r),
    w: ie(i[4], r),
    d: ie(i[5], r),
    h: ie(i[6], r),
    m: ie(i[7], r),
    s: ie(i[8], r)
  }) : s == null ? s = {} : typeof s == "object" && ("from" in s || "to" in s) && (a = sn(
    S(s.from),
    S(s.to)
  ), s = {}, s.ms = a.milliseconds, s.M = a.months), n = new Be(s), Pe(e) && y(e, "_locale") && (n._locale = e._locale), Pe(e) && y(e, "_isValid") && (n._isValid = e._isValid), n;
}
U.fn = Be.prototype;
U.invalid = Hr;
function ie(e, t) {
  var s = e && parseFloat(e.replace(",", "."));
  return (isNaN(s) ? 0 : s) * t;
}
function Ft(e, t) {
  var s = {};
  return s.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(s.months, "M").isAfter(t) && --s.months, s.milliseconds = +t - +e.clone().add(s.months, "M"), s;
}
function sn(e, t) {
  var s;
  return e.isValid() && t.isValid() ? (t = Yt(t, e), e.isBefore(t) ? s = Ft(e, t) : (s = Ft(t, e), s.milliseconds = -s.milliseconds, s.months = -s.months), s) : { milliseconds: 0, months: 0 };
}
function ms(e, t) {
  return function(s, i) {
    var r, n;
    return i !== null && !isNaN(+i) && (Vt(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), n = s, s = i, i = n), r = U(s, i), _s(this, r, e), this;
  };
}
function _s(e, t, s, i) {
  var r = t._milliseconds, n = at(t._days), a = at(t._months);
  e.isValid() && (i = i ?? !0, a && Xt(e, Re(e, "Month") + a * s), n && zt(e, "Date", Re(e, "Date") + n * s), r && e._d.setTime(e._d.valueOf() + r * s), i && o.updateOffset(e, n || a));
}
var rn = ms(1, "add"), nn = ms(-1, "subtract");
function ys(e) {
  return typeof e == "string" || e instanceof String;
}
function an(e) {
  return I(e) || De(e) || ys(e) || q(e) || on(e) || ln(e) || e === null || e === void 0;
}
function ln(e) {
  var t = ne(e) && !ut(e), s = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], r, n, a = i.length;
  for (r = 0; r < a; r += 1)
    n = i[r], s = s || y(e, n);
  return t && s;
}
function on(e) {
  var t = L(e), s = !1;
  return t && (s = e.filter(function(i) {
    return !q(i) && ys(e);
  }).length === 0), t && s;
}
function un(e) {
  var t = ne(e) && !ut(e), s = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], r, n;
  for (r = 0; r < i.length; r += 1)
    n = i[r], s = s || y(e, n);
  return t && s;
}
function dn(e, t) {
  var s = e.diff(t, "days", !0);
  return s < -6 ? "sameElse" : s < -1 ? "lastWeek" : s < 0 ? "lastDay" : s < 1 ? "sameDay" : s < 2 ? "nextDay" : s < 7 ? "nextWeek" : "sameElse";
}
function cn(e, t) {
  arguments.length === 1 && (arguments[0] ? an(arguments[0]) ? (e = arguments[0], t = void 0) : un(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var s = e || S(), i = Yt(s, this).startOf("day"), r = o.calendarFormat(this, i) || "sameElse", n = t && (V(t[r]) ? t[r].call(this, s) : t[r]);
  return this.format(
    n || this.localeData().calendar(r, this, S(s))
  );
}
function hn() {
  return new Ye(this);
}
function fn(e, t) {
  var s = I(e) ? e : S(e);
  return this.isValid() && s.isValid() ? (t = F(t) || "millisecond", t === "millisecond" ? this.valueOf() > s.valueOf() : s.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function mn(e, t) {
  var s = I(e) ? e : S(e);
  return this.isValid() && s.isValid() ? (t = F(t) || "millisecond", t === "millisecond" ? this.valueOf() < s.valueOf() : this.clone().endOf(t).valueOf() < s.valueOf()) : !1;
}
function _n(e, t, s, i) {
  var r = I(e) ? e : S(e), n = I(t) ? t : S(t);
  return this.isValid() && r.isValid() && n.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(r, s) : !this.isBefore(r, s)) && (i[1] === ")" ? this.isBefore(n, s) : !this.isAfter(n, s))) : !1;
}
function yn(e, t) {
  var s = I(e) ? e : S(e), i;
  return this.isValid() && s.isValid() ? (t = F(t) || "millisecond", t === "millisecond" ? this.valueOf() === s.valueOf() : (i = s.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function pn(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function wn(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function gn(e, t, s) {
  var i, r, n;
  if (!this.isValid())
    return NaN;
  if (i = Yt(e, this), !i.isValid())
    return NaN;
  switch (r = (i.utcOffset() - this.utcOffset()) * 6e4, t = F(t), t) {
    case "year":
      n = Ce(this, i) / 12;
      break;
    case "month":
      n = Ce(this, i);
      break;
    case "quarter":
      n = Ce(this, i) / 3;
      break;
    case "second":
      n = (this - i) / 1e3;
      break;
    case "minute":
      n = (this - i) / 6e4;
      break;
    case "hour":
      n = (this - i) / 36e5;
      break;
    case "day":
      n = (this - i - r) / 864e5;
      break;
    case "week":
      n = (this - i - r) / 6048e5;
      break;
    default:
      n = this - i;
  }
  return s ? n : C(n);
}
function Ce(e, t) {
  if (e.date() < t.date())
    return -Ce(t, e);
  var s = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(s, "months"), r, n;
  return t - i < 0 ? (r = e.clone().add(s - 1, "months"), n = (t - i) / (i - r)) : (r = e.clone().add(s + 1, "months"), n = (t - i) / (r - i)), -(s + n) || 0;
}
o.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
o.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Sn() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function kn(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, s = t ? this.clone().utc() : this;
  return s.year() < 0 || s.year() > 9999 ? Ne(
    s,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : V(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Ne(s, "Z")) : Ne(
    s,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function vn() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", s, i, r, n;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), s = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = "-MM-DD[T]HH:mm:ss.SSS", n = t + '[")]', this.format(s + i + r + n);
}
function Mn(e) {
  e || (e = this.isUtc() ? o.defaultFormatUtc : o.defaultFormat);
  var t = Ne(this, e);
  return this.localeData().postformat(t);
}
function Dn(e, t) {
  return this.isValid() && (I(e) && e.isValid() || S(e).isValid()) ? U({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Yn(e) {
  return this.from(S(), e);
}
function On(e, t) {
  return this.isValid() && (I(e) && e.isValid() || S(e).isValid()) ? U({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function bn(e) {
  return this.to(S(), e);
}
function ps(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = J(e), t != null && (this._locale = t), this);
}
var ws = R(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function gs() {
  return this._locale;
}
var Le = 1e3, ce = 60 * Le, Ie = 60 * ce, Ss = (365 * 400 + 97) * 24 * Ie;
function he(e, t) {
  return (e % t + t) % t;
}
function ks(e, t, s) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, s) - Ss : new Date(e, t, s).valueOf();
}
function vs(e, t, s) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, s) - Ss : Date.UTC(e, t, s);
}
function xn(e) {
  var t, s;
  if (e = F(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (s = this._isUTC ? vs : ks, e) {
    case "year":
      t = s(this.year(), 0, 1);
      break;
    case "quarter":
      t = s(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = s(this.year(), this.month(), 1);
      break;
    case "week":
      t = s(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = s(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = s(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= he(
        t + (this._isUTC ? 0 : this.utcOffset() * ce),
        Ie
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= he(t, ce);
      break;
    case "second":
      t = this._d.valueOf(), t -= he(t, Le);
      break;
  }
  return this._d.setTime(t), o.updateOffset(this, !0), this;
}
function Tn(e) {
  var t, s;
  if (e = F(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (s = this._isUTC ? vs : ks, e) {
    case "year":
      t = s(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = s(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = s(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = s(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = s(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = s(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Ie - he(
        t + (this._isUTC ? 0 : this.utcOffset() * ce),
        Ie
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += ce - he(t, ce) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Le - he(t, Le) - 1;
      break;
  }
  return this._d.setTime(t), o.updateOffset(this, !0), this;
}
function Nn() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Pn() {
  return Math.floor(this.valueOf() / 1e3);
}
function Cn() {
  return new Date(this.valueOf());
}
function Rn() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Fn() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Wn() {
  return this.isValid() ? this.toISOString() : null;
}
function Ln() {
  return dt(this);
}
function In() {
  return K({}, h(this));
}
function Un() {
  return h(this).overflow;
}
function An() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
c("N", 0, 0, "eraAbbr");
c("NN", 0, 0, "eraAbbr");
c("NNN", 0, 0, "eraAbbr");
c("NNNN", 0, 0, "eraName");
c("NNNNN", 0, 0, "eraNarrow");
c("y", ["y", 1], "yo", "eraYear");
c("y", ["yy", 2], 0, "eraYear");
c("y", ["yyy", 3], 0, "eraYear");
c("y", ["yyyy", 4], 0, "eraYear");
u("N", Ot);
u("NN", Ot);
u("NNN", Ot);
u("NNNN", Jn);
u("NNNNN", Qn);
g(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, s, i) {
    var r = s._locale.erasParse(e, i, s._strict);
    r ? h(s).era = r : h(s).invalidEra = e;
  }
);
u("y", me);
u("yy", me);
u("yyy", me);
u("yyyy", me);
u("yo", Xn);
g(["y", "yy", "yyy", "yyyy"], Y);
g(["yo"], function(e, t, s, i) {
  var r;
  s._locale._eraYearOrdinalRegex && (r = e.match(s._locale._eraYearOrdinalRegex)), s._locale.eraYearOrdinalParse ? t[Y] = s._locale.eraYearOrdinalParse(e, r) : t[Y] = parseInt(e, 10);
});
function En(e, t) {
  var s, i, r, n = this._eras || J("en")._eras;
  for (s = 0, i = n.length; s < i; ++s) {
    switch (typeof n[s].since) {
      case "string":
        r = o(n[s].since).startOf("day"), n[s].since = r.valueOf();
        break;
    }
    switch (typeof n[s].until) {
      case "undefined":
        n[s].until = 1 / 0;
        break;
      case "string":
        r = o(n[s].until).startOf("day").valueOf(), n[s].until = r.valueOf();
        break;
    }
  }
  return n;
}
function Hn(e, t, s) {
  var i, r, n = this.eras(), a, d, f;
  for (e = e.toUpperCase(), i = 0, r = n.length; i < r; ++i)
    if (a = n[i].name.toUpperCase(), d = n[i].abbr.toUpperCase(), f = n[i].narrow.toUpperCase(), s)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (d === e)
            return n[i];
          break;
        case "NNNN":
          if (a === e)
            return n[i];
          break;
        case "NNNNN":
          if (f === e)
            return n[i];
          break;
      }
    else if ([a, d, f].indexOf(e) >= 0)
      return n[i];
}
function Vn(e, t) {
  var s = e.since <= e.until ? 1 : -1;
  return t === void 0 ? o(e.since).year() : o(e.since).year() + (t - e.offset) * s;
}
function $n() {
  var e, t, s, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (s = this.clone().startOf("day").valueOf(), i[e].since <= s && s <= i[e].until || i[e].until <= s && s <= i[e].since)
      return i[e].name;
  return "";
}
function Gn() {
  var e, t, s, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (s = this.clone().startOf("day").valueOf(), i[e].since <= s && s <= i[e].until || i[e].until <= s && s <= i[e].since)
      return i[e].narrow;
  return "";
}
function zn() {
  var e, t, s, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (s = this.clone().startOf("day").valueOf(), i[e].since <= s && s <= i[e].until || i[e].until <= s && s <= i[e].since)
      return i[e].abbr;
  return "";
}
function jn() {
  var e, t, s, i, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (s = r[e].since <= r[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), r[e].since <= i && i <= r[e].until || r[e].until <= i && i <= r[e].since)
      return (this.year() - o(r[e].since).year()) * s + r[e].offset;
  return this.year();
}
function Zn(e) {
  return y(this, "_erasNameRegex") || bt.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Bn(e) {
  return y(this, "_erasAbbrRegex") || bt.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function qn(e) {
  return y(this, "_erasNarrowRegex") || bt.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Ot(e, t) {
  return t.erasAbbrRegex(e);
}
function Jn(e, t) {
  return t.erasNameRegex(e);
}
function Qn(e, t) {
  return t.erasNarrowRegex(e);
}
function Xn(e, t) {
  return t._eraYearOrdinalRegex || me;
}
function bt() {
  var e = [], t = [], s = [], i = [], r, n, a = this.eras();
  for (r = 0, n = a.length; r < n; ++r)
    t.push(N(a[r].name)), e.push(N(a[r].abbr)), s.push(N(a[r].narrow)), i.push(N(a[r].name)), i.push(N(a[r].abbr)), i.push(N(a[r].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  );
}
c(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
c(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function qe(e, t) {
  c(0, [e, e.length], 0, t);
}
qe("gggg", "weekYear");
qe("ggggg", "weekYear");
qe("GGGG", "isoWeekYear");
qe("GGGGG", "isoWeekYear");
O("weekYear", "gg");
O("isoWeekYear", "GG");
b("weekYear", 1);
b("isoWeekYear", 1);
u("G", Ge);
u("g", Ge);
u("GG", k, P);
u("gg", k, P);
u("GGGG", yt, _t);
u("gggg", yt, _t);
u("GGGGG", $e, He);
u("ggggg", $e, He);
be(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, s, i) {
    t[i.substr(0, 2)] = m(e);
  }
);
be(["gg", "GG"], function(e, t, s, i) {
  t[i] = o.parseTwoDigitYear(e);
});
function Kn(e) {
  return Ms.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function ea(e) {
  return Ms.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function ta() {
  return B(this.year(), 1, 4);
}
function sa() {
  return B(this.isoWeekYear(), 1, 4);
}
function ia() {
  var e = this.localeData()._week;
  return B(this.year(), e.dow, e.doy);
}
function ra() {
  var e = this.localeData()._week;
  return B(this.weekYear(), e.dow, e.doy);
}
function Ms(e, t, s, i, r) {
  var n;
  return e == null ? ke(this, i, r).year : (n = B(e, i, r), t > n && (t = n), na.call(this, e, t, s, i, r));
}
function na(e, t, s, i, r) {
  var n = ss(e, t, s, i, r), a = Se(n.year, 0, n.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
c("Q", 0, "Qo", "quarter");
O("quarter", "Q");
b("quarter", 7);
u("Q", jt);
g("Q", function(e, t) {
  t[j] = (m(e) - 1) * 3;
});
function aa(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
c("D", ["DD", 2], "Do", "date");
O("date", "D");
b("date", 9);
u("D", k);
u("DD", k, P);
u("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
g(["D", "DD"], A);
g("Do", function(e, t) {
  t[A] = m(e.match(k)[0]);
});
var Ds = fe("Date", !0);
c("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
O("dayOfYear", "DDD");
b("dayOfYear", 4);
u("DDD", Ve);
u("DDDD", Zt);
g(["DDD", "DDDD"], function(e, t, s) {
  s._dayOfYear = m(e);
});
function la(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
c("m", ["mm", 2], 0, "minute");
O("minute", "m");
b("minute", 14);
u("m", k);
u("mm", k, P);
g(["m", "mm"], W);
var oa = fe("Minutes", !1);
c("s", ["ss", 2], 0, "second");
O("second", "s");
b("second", 15);
u("s", k);
u("ss", k, P);
g(["s", "ss"], Z);
var ua = fe("Seconds", !1);
c("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
c(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
c(0, ["SSS", 3], 0, "millisecond");
c(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
c(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
c(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
c(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
c(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
c(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
O("millisecond", "ms");
b("millisecond", 16);
u("S", Ve, jt);
u("SS", Ve, P);
u("SSS", Ve, Zt);
var ee, Ys;
for (ee = "SSSS"; ee.length <= 9; ee += "S")
  u(ee, me);
function da(e, t) {
  t[re] = m(("0." + e) * 1e3);
}
for (ee = "S"; ee.length <= 9; ee += "S")
  g(ee, da);
Ys = fe("Milliseconds", !1);
c("z", 0, 0, "zoneAbbr");
c("zz", 0, 0, "zoneName");
function ca() {
  return this._isUTC ? "UTC" : "";
}
function ha() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var l = Ye.prototype;
l.add = rn;
l.calendar = cn;
l.clone = hn;
l.diff = gn;
l.endOf = Tn;
l.format = Mn;
l.from = Dn;
l.fromNow = Yn;
l.to = On;
l.toNow = bn;
l.get = fi;
l.invalidAt = Un;
l.isAfter = fn;
l.isBefore = mn;
l.isBetween = _n;
l.isSame = yn;
l.isSameOrAfter = pn;
l.isSameOrBefore = wn;
l.isValid = Ln;
l.lang = ws;
l.locale = ps;
l.localeData = gs;
l.max = Wr;
l.min = Fr;
l.parsingFlags = In;
l.set = mi;
l.startOf = xn;
l.subtract = nn;
l.toArray = Rn;
l.toObject = Fn;
l.toDate = Cn;
l.toISOString = kn;
l.inspect = vn;
typeof Symbol < "u" && Symbol.for != null && (l[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
l.toJSON = Wn;
l.toString = Sn;
l.unix = Pn;
l.valueOf = Nn;
l.creationData = An;
l.eraName = $n;
l.eraNarrow = Gn;
l.eraAbbr = zn;
l.eraYear = jn;
l.year = ts;
l.isLeapYear = Ri;
l.weekYear = Kn;
l.isoWeekYear = ea;
l.quarter = l.quarters = aa;
l.month = Kt;
l.daysInMonth = Ni;
l.week = l.weeks = Ai;
l.isoWeek = l.isoWeeks = Ei;
l.weeksInYear = ia;
l.weeksInWeekYear = ra;
l.isoWeeksInYear = ta;
l.isoWeeksInISOWeekYear = sa;
l.date = Ds;
l.day = l.days = Ki;
l.weekday = er;
l.isoWeekday = tr;
l.dayOfYear = la;
l.hour = l.hours = or;
l.minute = l.minutes = oa;
l.second = l.seconds = ua;
l.millisecond = l.milliseconds = Ys;
l.utcOffset = Gr;
l.utc = jr;
l.local = Zr;
l.parseZone = Br;
l.hasAlignedHourOffset = qr;
l.isDST = Jr;
l.isLocal = Xr;
l.isUtcOffset = Kr;
l.isUtc = fs;
l.isUTC = fs;
l.zoneAbbr = ca;
l.zoneName = ha;
l.dates = R(
  "dates accessor is deprecated. Use date instead.",
  Ds
);
l.months = R(
  "months accessor is deprecated. Use month instead",
  Kt
);
l.years = R(
  "years accessor is deprecated. Use year instead",
  ts
);
l.zone = R(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  zr
);
l.isDSTShifted = R(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Qr
);
function fa(e) {
  return S(e * 1e3);
}
function ma() {
  return S.apply(null, arguments).parseZone();
}
function Os(e) {
  return e;
}
var p = ht.prototype;
p.calendar = Ks;
p.longDateFormat = ii;
p.invalidDate = ni;
p.ordinal = oi;
p.preparse = Os;
p.postformat = Os;
p.relativeTime = di;
p.pastFuture = ci;
p.set = Qs;
p.eras = En;
p.erasParse = Hn;
p.erasConvertYear = Vn;
p.erasAbbrRegex = Bn;
p.erasNameRegex = Zn;
p.erasNarrowRegex = qn;
p.months = Oi;
p.monthsShort = bi;
p.monthsParse = Ti;
p.monthsRegex = Ci;
p.monthsShortRegex = Pi;
p.week = Wi;
p.firstDayOfYear = Ui;
p.firstDayOfWeek = Ii;
p.weekdays = Bi;
p.weekdaysMin = Ji;
p.weekdaysShort = qi;
p.weekdaysParse = Xi;
p.weekdaysRegex = sr;
p.weekdaysShortRegex = ir;
p.weekdaysMinRegex = rr;
p.isPM = ar;
p.meridiem = ur;
function Ue(e, t, s, i) {
  var r = J(), n = H().set(i, t);
  return r[s](n, e);
}
function bs(e, t, s) {
  if (q(e) && (t = e, e = void 0), e = e || "", t != null)
    return Ue(e, t, s, "month");
  var i, r = [];
  for (i = 0; i < 12; i++)
    r[i] = Ue(e, i, s, "month");
  return r;
}
function xt(e, t, s, i) {
  typeof e == "boolean" ? (q(t) && (s = t, t = void 0), t = t || "") : (t = e, s = t, e = !1, q(t) && (s = t, t = void 0), t = t || "");
  var r = J(), n = e ? r._week.dow : 0, a, d = [];
  if (s != null)
    return Ue(t, (s + n) % 7, i, "day");
  for (a = 0; a < 7; a++)
    d[a] = Ue(t, (a + n) % 7, i, "day");
  return d;
}
function _a(e, t) {
  return bs(e, t, "months");
}
function ya(e, t) {
  return bs(e, t, "monthsShort");
}
function pa(e, t, s) {
  return xt(e, t, s, "weekdays");
}
function wa(e, t, s) {
  return xt(e, t, s, "weekdaysShort");
}
function ga(e, t, s) {
  return xt(e, t, s, "weekdaysMin");
}
te("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, s = m(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + s;
  }
});
o.lang = R(
  "moment.lang is deprecated. Use moment.locale instead.",
  te
);
o.langData = R(
  "moment.langData is deprecated. Use moment.localeData instead.",
  J
);
var G = Math.abs;
function Sa() {
  var e = this._data;
  return this._milliseconds = G(this._milliseconds), this._days = G(this._days), this._months = G(this._months), e.milliseconds = G(e.milliseconds), e.seconds = G(e.seconds), e.minutes = G(e.minutes), e.hours = G(e.hours), e.months = G(e.months), e.years = G(e.years), this;
}
function xs(e, t, s, i) {
  var r = U(t, s);
  return e._milliseconds += i * r._milliseconds, e._days += i * r._days, e._months += i * r._months, e._bubble();
}
function ka(e, t) {
  return xs(this, e, t, 1);
}
function va(e, t) {
  return xs(this, e, t, -1);
}
function Wt(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Ma() {
  var e = this._milliseconds, t = this._days, s = this._months, i = this._data, r, n, a, d, f;
  return e >= 0 && t >= 0 && s >= 0 || e <= 0 && t <= 0 && s <= 0 || (e += Wt(ot(s) + t) * 864e5, t = 0, s = 0), i.milliseconds = e % 1e3, r = C(e / 1e3), i.seconds = r % 60, n = C(r / 60), i.minutes = n % 60, a = C(n / 60), i.hours = a % 24, t += C(a / 24), f = C(Ts(t)), s += f, t -= Wt(ot(f)), d = C(s / 12), s %= 12, i.days = t, i.months = s, i.years = d, this;
}
function Ts(e) {
  return e * 4800 / 146097;
}
function ot(e) {
  return e * 146097 / 4800;
}
function Da(e) {
  if (!this.isValid())
    return NaN;
  var t, s, i = this._milliseconds;
  if (e = F(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, s = this._months + Ts(t), e) {
      case "month":
        return s;
      case "quarter":
        return s / 3;
      case "year":
        return s / 12;
    }
  else
    switch (t = this._days + Math.round(ot(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Ya() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + m(this._months / 12) * 31536e6 : NaN;
}
function Q(e) {
  return function() {
    return this.as(e);
  };
}
var Oa = Q("ms"), ba = Q("s"), xa = Q("m"), Ta = Q("h"), Na = Q("d"), Pa = Q("w"), Ca = Q("M"), Ra = Q("Q"), Fa = Q("y");
function Wa() {
  return U(this);
}
function La(e) {
  return e = F(e), this.isValid() ? this[e + "s"]() : NaN;
}
function ae(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Ia = ae("milliseconds"), Ua = ae("seconds"), Aa = ae("minutes"), Ea = ae("hours"), Ha = ae("days"), Va = ae("months"), $a = ae("years");
function Ga() {
  return C(this.days() / 7);
}
var z = Math.round, ue = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function za(e, t, s, i, r) {
  return r.relativeTime(t || 1, !!s, e, i);
}
function ja(e, t, s, i) {
  var r = U(e).abs(), n = z(r.as("s")), a = z(r.as("m")), d = z(r.as("h")), f = z(r.as("d")), w = z(r.as("M")), x = z(r.as("w")), $ = z(r.as("y")), X = n <= s.ss && ["s", n] || n < s.s && ["ss", n] || a <= 1 && ["m"] || a < s.m && ["mm", a] || d <= 1 && ["h"] || d < s.h && ["hh", d] || f <= 1 && ["d"] || f < s.d && ["dd", f];
  return s.w != null && (X = X || x <= 1 && ["w"] || x < s.w && ["ww", x]), X = X || w <= 1 && ["M"] || w < s.M && ["MM", w] || $ <= 1 && ["y"] || ["yy", $], X[2] = t, X[3] = +e > 0, X[4] = i, za.apply(null, X);
}
function Za(e) {
  return e === void 0 ? z : typeof e == "function" ? (z = e, !0) : !1;
}
function Ba(e, t) {
  return ue[e] === void 0 ? !1 : t === void 0 ? ue[e] : (ue[e] = t, e === "s" && (ue.ss = t - 1), !0);
}
function qa(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var s = !1, i = ue, r, n;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (s = e), typeof t == "object" && (i = Object.assign({}, ue, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), r = this.localeData(), n = ja(this, !s, i, r), s && (n = r.pastFuture(+this, n)), r.postformat(n);
}
var tt = Math.abs;
function le(e) {
  return (e > 0) - (e < 0) || +e;
}
function Je() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = tt(this._milliseconds) / 1e3, t = tt(this._days), s = tt(this._months), i, r, n, a, d = this.asSeconds(), f, w, x, $;
  return d ? (i = C(e / 60), r = C(i / 60), e %= 60, i %= 60, n = C(s / 12), s %= 12, a = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", f = d < 0 ? "-" : "", w = le(this._months) !== le(d) ? "-" : "", x = le(this._days) !== le(d) ? "-" : "", $ = le(this._milliseconds) !== le(d) ? "-" : "", f + "P" + (n ? w + n + "Y" : "") + (s ? w + s + "M" : "") + (t ? x + t + "D" : "") + (r || i || e ? "T" : "") + (r ? $ + r + "H" : "") + (i ? $ + i + "M" : "") + (e ? $ + a + "S" : "")) : "P0D";
}
var _ = Be.prototype;
_.isValid = Er;
_.abs = Sa;
_.add = ka;
_.subtract = va;
_.as = Da;
_.asMilliseconds = Oa;
_.asSeconds = ba;
_.asMinutes = xa;
_.asHours = Ta;
_.asDays = Na;
_.asWeeks = Pa;
_.asMonths = Ca;
_.asQuarters = Ra;
_.asYears = Fa;
_.valueOf = Ya;
_._bubble = Ma;
_.clone = Wa;
_.get = La;
_.milliseconds = Ia;
_.seconds = Ua;
_.minutes = Aa;
_.hours = Ea;
_.days = Ha;
_.weeks = Ga;
_.months = Va;
_.years = $a;
_.humanize = qa;
_.toISOString = Je;
_.toString = Je;
_.toJSON = Je;
_.locale = ps;
_.localeData = gs;
_.toIsoString = R(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Je
);
_.lang = ws;
c("X", 0, 0, "unix");
c("x", 0, 0, "valueOf");
u("x", Ge);
u("X", yi);
g("X", function(e, t, s) {
  s._d = new Date(parseFloat(e) * 1e3);
});
g("x", function(e, t, s) {
  s._d = new Date(m(e));
});
//! moment.js
o.version = "2.29.4";
qs(S);
o.fn = l;
o.min = Lr;
o.max = Ir;
o.now = Ur;
o.utc = H;
o.unix = fa;
o.months = _a;
o.isDate = De;
o.locale = te;
o.invalid = Ae;
o.duration = U;
o.isMoment = I;
o.weekdays = pa;
o.parseZone = ma;
o.localeData = J;
o.isDuration = Pe;
o.monthsShort = ya;
o.weekdaysMin = ga;
o.defineLocale = St;
o.updateLocale = fr;
o.locales = mr;
o.weekdaysShort = wa;
o.normalizeUnits = F;
o.relativeTimeRounding = Za;
o.relativeTimeThreshold = Ba;
o.calendarFormat = dn;
o.prototype = l;
o.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Ja = {
  name: "FileIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Qa = function() {
  var t = this, s = t._self._c;
  return s("span", t._b({ staticClass: "material-design-icon file-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(i) {
    return t.$emit("click", i);
  } } }, "span", t.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" } }, [t.title ? s("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, Xa = [], Ka = /* @__PURE__ */ Me(
  Ja,
  Qa,
  Xa,
  !1,
  null,
  null,
  null,
  null
);
const el = Ka.exports, Lt = 64, tl = It.extend({
  name: "NodesPicker",
  components: {
    FileSvg: el,
    NcCheckboxRadioSwitch: Ut
  },
  props: {
    incoming: {
      type: [Cs, File, Tt, Nt],
      required: !0
    },
    existing: {
      type: [Tt, Nt],
      required: !0
    },
    newSelected: {
      type: Array,
      required: !0
    },
    oldSelected: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      asyncPreview: null
    };
  },
  computed: {
    /**
     * Whether the incoming or existing file is selected.
     * This is used by the parent component to ensure
     * that the user has selected at least one of the two files.
     */
    isEnoughSelected() {
      return this.isChecked(this.incoming, this.newSelected) || this.isChecked(this.existing, this.oldSelected);
    },
    incomingPreview() {
      return this.asyncPreview ? this.asyncPreview : this.previewUrl(this.incoming);
    },
    existingPreview() {
      return this.previewUrl(this.existing);
    }
  },
  methods: {
    lastModified(e) {
      const t = e instanceof File ? new Date(e.lastModified) : e.mtime;
      return t ? o(t).format("LLL") : pe("Last modified date unknown");
    },
    size(e) {
      return e.size ? Rs(e.size, !0) : pe("Unknown size");
    },
    previewUrl(e) {
      if (e instanceof File) {
        this.previewImage(e).then((t) => {
          this.asyncPreview = t;
        });
        return;
      }
      if (e.type === Fs.Folder)
        return null;
      try {
        const t = e.attributes.previewUrl || Us("/core/preview?fileId={fileid}", {
          fileid: e.fileid
        }), s = new URL(window.location.origin + t);
        return s.searchParams.set("x", Lt.toString()), s.searchParams.set("y", Lt.toString()), s.searchParams.set("mimeFallback", "true"), s.href;
      } catch {
        return null;
      }
    },
    isChecked(e, t) {
      return t.includes(e);
    },
    onUpdateChecked(e, t) {
      this.$emit(`update:${t}`, ...args);
    },
    onUpdateIncomingChecked(e) {
      e ? this.$emit("update:newSelected", [this.incoming, ...this.newSelected]) : this.$emit("update:newSelected", this.newSelected.filter((t) => t !== this.incoming));
    },
    onUpdateExistingChecked(e) {
      e ? this.$emit("update:oldSelected", [this.existing, ...this.oldSelected]) : this.$emit("update:oldSelected", this.oldSelected.filter((t) => t !== this.existing));
    },
    /**
     * Get the preview Image of a file
     * @param file the soon-to-be-uploaded File
     */
    async previewImage(e) {
      return new Promise((t) => {
        if (e.type.startsWith("image/")) {
          const s = new FileReader();
          s.onload = async (i) => {
            const r = i?.target?.result;
            if (r instanceof ArrayBuffer) {
              const n = new Blob([r], { type: e.type }), a = URL.createObjectURL(n);
              t(a);
              return;
            }
            t(null);
          }, s.readAsArrayBuffer(e);
        }
      });
    },
    t: pe
  }
});
var sl = function() {
  var t = this, s = t._self._c;
  return t._self._setupProxy, s("fieldset", { staticClass: "node-picker__wrapper", attrs: { "data-cy-conflict-picker-fieldset": t.existing.basename } }, [s("legend", [t._v(t._s(t.existing.basename))]), s("NcCheckboxRadioSwitch", { attrs: { checked: t.isChecked(t.incoming, t.newSelected), required: !t.isEnoughSelected, "data-cy-conflict-picker-input-incoming": t.existing.basename }, on: { "update:checked": t.onUpdateIncomingChecked } }, [s("span", { staticClass: "node-picker node-picker--incoming" }, [t.incomingPreview ? s("img", { staticClass: "node-picker__preview", attrs: { src: t.incomingPreview, alt: t.t("Preview image"), loading: "lazy" } }) : s("FileSvg", { staticClass: "node-picker__icon", attrs: { size: 48 } }), s("span", { staticClass: "node-picker__desc" }, [s("span", { staticClass: "node-picker__name" }, [t._v(t._s(t.t("New version")))]), s("span", { staticClass: "node-picker__mtime" }, [t._v(t._s(t.lastModified(t.incoming)))]), s("span", { staticClass: "node-picker__size" }, [t._v(t._s(t.size(t.incoming)))])])], 1)]), s("NcCheckboxRadioSwitch", { attrs: { checked: t.isChecked(t.existing, t.oldSelected), required: !t.isEnoughSelected, "data-cy-conflict-picker-input-existing": t.existing.basename }, on: { "update:checked": t.onUpdateExistingChecked } }, [s("span", { staticClass: "node-picker node-picker--existing" }, [t.existingPreview ? s("img", { staticClass: "node-picker__preview", attrs: { src: t.existingPreview, alt: t.t("Preview image"), loading: "lazy" } }) : s("FileSvg", { staticClass: "node-picker__icon", attrs: { size: 48 } }), s("span", { staticClass: "node-picker__desc" }, [s("span", { staticClass: "node-picker__name" }, [t._v(t._s(t.t("Existing version")))]), s("span", { staticClass: "node-picker__mtime" }, [t._v(t._s(t.lastModified(t.existing)))]), s("span", { staticClass: "node-picker__size" }, [t._v(t._s(t.size(t.existing)))])])], 1)])], 1);
}, il = [], rl = /* @__PURE__ */ Me(
  tl,
  sl,
  il,
  !1,
  null,
  "cc039314",
  null,
  null
);
const nl = rl.exports, al = It.extend({
  name: "ConflictPicker",
  components: {
    ArrowRight: $s,
    Close: Bs,
    NcButton: Ls,
    NcCheckboxRadioSwitch: Ut,
    NcModal: Is,
    NodesPicker: nl
  },
  props: {
    /** Directory/context file name */
    dirname: {
      type: String,
      default: ""
    },
    /** All the existing files in the current directory */
    content: {
      type: Array,
      required: !0
    },
    /** New files being moved/uploaded */
    conflicts: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      // computed list of conflicting files already present in the directory
      files: [],
      opened: !0,
      blockedTitle: pe("You need to select at least one version of each file to continue."),
      newSelected: [],
      oldSelected: []
    };
  },
  computed: {
    name() {
      return this?.dirname?.trim?.() !== "" ? Qe("{count} file conflict in {dirname}", "{count} file conflicts in {dirname}", this.conflicts.length, {
        count: this.conflicts.length,
        dirname: this.dirname
      }) : Qe("{count} file conflict", "{count} files conflict", this.conflicts.length, { count: this.conflicts.length });
    },
    skipButtonLabel() {
      return Qe("Skip this file", "Skip {count} files", this.conflicts.length, { count: this.conflicts.length });
    },
    // Select all incoming files
    selectAllNewBind() {
      const e = this.isNoneNewSelected || this.isSomeNewSelected ? this.t("Select all") : this.t("Unselect all");
      return {
        "aria-label": e,
        checked: this.isAllNewSelected,
        indeterminate: this.isSomeNewSelected,
        title: e
      };
    },
    isAllNewSelected() {
      return this.newSelected.length === this.conflicts.length;
    },
    isNoneNewSelected() {
      return this.newSelected.length === 0;
    },
    isSomeNewSelected() {
      return !this.isAllNewSelected && !this.isNoneNewSelected;
    },
    // Select all existing files
    selectAllOldBind() {
      const e = this.isNoneOldSelected || this.isSomeOldSelected ? this.t("Select all") : this.t("Unselect all");
      return {
        "aria-label": e,
        checked: this.isAllOldSelected,
        indeterminate: this.isSomeOldSelected,
        title: e
      };
    },
    isAllOldSelected() {
      return this.oldSelected.length === this.files.length;
    },
    isNoneOldSelected() {
      return this.oldSelected.length === 0;
    },
    isSomeOldSelected() {
      return !this.isAllOldSelected && !this.isNoneOldSelected;
    },
    // Global handlings
    isEnoughSelected() {
      return this.isAllOldSelected || this.isAllNewSelected ? !0 : this.$refs?.nodesPicker?.every?.((e) => e.isEnoughSelected);
    }
  },
  beforeMount() {
    if (this.files = this.conflicts.map((e) => {
      const t = e instanceof File ? e.name : e.basename;
      return this.content.find((s) => s.basename === t);
    }).filter(Boolean), se.debug("ConflictPicker initialised", { files: this.files, conflicts: this.conflicts, content: this.content }), this.conflicts.length === 0 || this.files.length === 0) {
      const e = new Error("ConflictPicker: files and conflicts must not be empty");
      throw this.onCancel(e), e;
    }
    if (this.conflicts.length !== this.files.length) {
      const e = new Error("ConflictPicker: files and conflicts must have the same length");
      throw this.onCancel(e), e;
    }
  },
  methods: {
    onCancel(e) {
      this.opened = !1, this.$emit("cancel", e);
    },
    onSkip() {
      se.debug("Conflict skipped. Ignoring all conflicting files"), this.opened = !1, this.$emit("submit", {
        selected: [],
        renamed: []
      });
    },
    onSubmit() {
      if (!this.isEnoughSelected) {
        this.scrollValidityInputIntoView(), this.$refs.form.reportValidity(), Ws(this.blockedTitle);
        return;
      }
      const e = this.oldSelected.map((n) => n.basename), t = this.content.map((n) => n.basename), s = [], i = this.newSelected.filter((n) => {
        const a = n instanceof File ? n.name : n.basename;
        return e.includes(a);
      });
      i.length > 0 && i.forEach((n) => {
        const a = n instanceof File ? n.name : n.basename, d = this.getUniqueName(a, t);
        if (n instanceof File) {
          n = new File([n], d, { type: n.type, lastModified: n.lastModified }), s.push(n);
          return;
        }
        n.rename(d), s.push(n);
      });
      const r = this.newSelected.filter((n) => {
        const a = n instanceof File ? n.name : n.basename;
        return !e.includes(a);
      });
      se.debug("Conflict resolved", { selected: r, renamed: s }), this.opened = !1, this.$emit("submit", {
        selected: r,
        renamed: s
      });
    },
    /**
     * Get a unique name for a file based
     * on the existing directory content.
     * @param {string} name The original file name with extension
     * @param {string} names The existing directory content names
     * @return {string} A unique name
     * TODO: migrate to @nextcloud/files
     */
    getUniqueName(e, t) {
      let s = e, i = 1;
      for (; t.includes(s); ) {
        const r = Ns(e);
        s = `${Ps(e, r)} (${i++})${r}`;
      }
      return s;
    },
    /**
     * Scroll the first invalid input into view.
     * This is needed because the browser uses behavior: "nearest" by default.
     */
    scrollValidityInputIntoView() {
      const e = '.checkbox-radio-switch input[type="checkbox"]';
      [...this.$el.querySelectorAll(e)].forEach((i) => i?.setCustomValidity?.(""));
      const s = this.$el.querySelector(e + ":invalid");
      s && (s.setCustomValidity(this.blockedTitle), s.scrollIntoView({ behavior: "instant", block: "center" }));
    },
    onSelectAllNew(e) {
      e ? (se.debug("Selected all new files"), this.newSelected = this.conflicts) : (se.debug("Cleared new selection"), this.newSelected = []);
    },
    onSelectAllOld(e) {
      e ? (se.debug("Selected all existing files"), this.oldSelected = this.files) : (se.debug("Cleared old selection"), this.oldSelected = []);
    },
    t: pe
  }
});
var ll = function() {
  var t = this, s = t._self._c;
  return t._self._setupProxy, s("NcModal", { staticClass: "conflict-picker", attrs: { "data-cy-conflict-picker": "", "close-on-click-outside": !1, show: t.opened, size: "large" }, on: { close: t.onCancel } }, [s("div", { staticClass: "conflict-picker__header" }, [s("h2", { staticClass: "conflict-picker__title", domProps: { textContent: t._s(t.name) } }), s("p", { staticClass: "conflict-picker__description", attrs: { id: "conflict-picker-description" } }, [t._v(" " + t._s(t.t("Which files do you want to keep?"))), s("br"), t._v(" " + t._s(t.t("If you select both versions, the copied file will have a number added to its name.")) + " ")])]), s("form", { ref: "form", staticClass: "conflict-picker__form", attrs: { "aria-labelledby": "conflict-picker-description", "data-cy-conflict-picker-form": "" }, on: { submit: function(i) {
    return i.preventDefault(), i.stopPropagation(), t.onSubmit.apply(null, arguments);
  } } }, [s("fieldset", { staticClass: "conflict-picker__all", attrs: { "data-cy-conflict-picker-fieldset": "all" } }, [s("legend", { staticClass: "hidden-visually" }, [t._v(t._s(t.t("Select all checkboxes")))]), s("NcCheckboxRadioSwitch", t._b({ attrs: { "data-cy-conflict-picker-input-incoming": "all" }, on: { "update:checked": t.onSelectAllNew } }, "NcCheckboxRadioSwitch", t.selectAllNewBind, !1), [t._v(" " + t._s(t.t("Select all new files")) + " ")]), s("NcCheckboxRadioSwitch", t._b({ attrs: { "data-cy-conflict-picker-input-existing": "all" }, on: { "update:checked": t.onSelectAllOld } }, "NcCheckboxRadioSwitch", t.selectAllOldBind, !1), [t._v(" " + t._s(t.t("Select all existing files")) + " ")])], 1), t._l(t.files, function(i, r) {
    return s("NodesPicker", { key: i.fileid, ref: "nodesPicker", refInFor: !0, attrs: { incoming: t.conflicts[r], existing: t.files[r], "new-selected": t.newSelected, "old-selected": t.oldSelected }, on: { "update:newSelected": function(n) {
      t.newSelected = n;
    }, "update:new-selected": function(n) {
      t.newSelected = n;
    }, "update:oldSelected": function(n) {
      t.oldSelected = n;
    }, "update:old-selected": function(n) {
      t.oldSelected = n;
    } } });
  })], 2), s("div", { staticClass: "conflict-picker__controls" }, [s("NcButton", { attrs: { "data-cy-conflict-picker-skip": "" }, on: { click: t.onSkip }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [s("Close")];
  }, proxy: !0 }]) }, [t._v(" " + t._s(t.skipButtonLabel) + " ")]), s("NcButton", { class: { "button-vue--disabled": !t.isEnoughSelected }, attrs: { type: "primary", title: t.isEnoughSelected ? "" : t.blockedTitle, "native-type": "submit", "data-cy-conflict-picker-submit": "" }, on: { click: function(i) {
    return i.stopPropagation(), i.preventDefault(), t.onSubmit.apply(null, arguments);
  } }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [s("ArrowRight")];
  }, proxy: !0 }]) }, [t._v(" " + t._s(t.t("Continue")) + " ")])], 1)]);
}, ol = [], ul = /* @__PURE__ */ Me(
  al,
  ll,
  ol,
  !1,
  null,
  "9de22627",
  null,
  null
);
const Sl = ul.exports;
export {
  Sl as default
};
